import AwesomeSearch from "@cahaba/XDL/Icons/AwesomeSearch";
import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

searchInputStyles.input = {
    sizeVariant: "default",
    iconProps: {
        src: AwesomeSearch,
        color: "#8E8F90",
        css: css`
            color: #8e8f90;
        `,
        size: 24,
    },
    border: "rectangle",
    cssOverrides: {
        formField: css`
            width: 100%;
            height: auto;
        `,
        formInputWrapper: css`
            button {
                background: transparent;
                width: 65px !important;
                height: 50px !important;
                border-radius: 0 3px 3px 0 !important;
            }

            button > [class^="IconWrapper"] {
                height: 21px !important;
                width: 20px !important;
                padding: 0;
                right: 23px;
                top: 14px;
            }

            button > span > svg {
                height: 28px;
                width: 28px;
            }
        `,
        inputSelect: css`
            border-radius: 3px;
            font-size: 14px;
            font-weight: 500;
            text-transform: uppercase;
            height: 50px;
            background-color: #f5f4f4;
        `,
    },
};

searchInputStyles.popover = {
    transitionDuration: "short",
    toggle: false,
    xPosition: "start",
};

searchInputStyles.popoverWrapper = {
    as: "div",
    _height: "auto",
    css: css`
        display: inline-flex;
        justify-content: flex-end;
    `,
};

searchInputStyles.popoverContentBody = {
    as: "div",
    _height: "100%",
};

searchInputStyles.autocompleteWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        flex-direction: column-reverse;
                    `,
                ],
                "max",
            )}
    `,
};

searchInputStyles.autocompleteColumnWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 375px;
        padding: 0 20px 15px 20px;
    `,
};
